export function keyBy<TItem extends Record<string, unknown>>(
  items: TItem[],
  key: keyof TItem,
): Record<TItem[keyof TItem] & (string | number | symbol), TItem> {
  return items.reduce(
    (acc, obj) => Object.assign(acc, { [String(obj[key])]: obj }),
    {} as Record<TItem[keyof TItem] & (string | number | symbol), TItem>,
  );
}
